export class CalculateTask {
  process: string;
  mode: string;

  constructor(process: string, mode: string) {
    this.process = process;
    this.mode = mode;
  }
}
